/**
 * Получение языка пользователя
 */
import { ApplicationShared } from "core";
import { getCookie, getTopDomain, setCookie } from "../../../../helpers/cookies";
import { DEZIIIGN_CONTEXTS, MEDIIIA_CONTEXTS } from "shared/constants/enginePaths";
import { AppTester } from "supporting";

type UserLang = 'ru' | 'en' | 'zh' | 'fr';

const LANG_STORAGE_KEY = 'brg_lang';
const KZ_LANG_STORAGE_KEY = 'brg_lang_kz';

const isUserLang = (lang: string | null): lang is UserLang => {
  if (!lang) return false;
  return ['ru', 'en', 'zh', 'fr'].includes(lang);
}

const getContextLang = () => {
  const app = ApplicationShared.application;

  if (typeof window !== 'undefined' && AppTester.isPromtWeekend()) {
    return 'ru';
  }

  if (['deziiign/lpudesign'].includes(app)) {
    return 'en';
  }
  if ([
    ...MEDIIIA_CONTEXTS,
    ...DEZIIIGN_CONTEXTS,
    'geograffee/dafes',
    'deziiign/lpudesign'
  ].includes(app)) {
    return 'ru';
  }
}

function getStoredLang(storageKey = LANG_STORAGE_KEY): UserLang | null {
  const cookieLang = getCookie(storageKey);
  if (isUserLang(cookieLang)) {
    return cookieLang;
  }
  const storageLang = localStorage.getItem(storageKey);
  if (isUserLang(storageLang)) {
    return storageLang;
  }
  return null;
}

const getLangFromUrl = (): UserLang | null => {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);
  const lang = urlParams.get('lang');

  if (isUserLang(lang)) {
    return lang;
  }
  return null;
}

const getKzLang = (): UserLang => {
  const kzStored = getStoredLang(KZ_LANG_STORAGE_KEY);
  if (kzStored === 'ru' || kzStored === 'en') {
    return kzStored;
  }

  // Legacy: раньше для dafes русский слот хранился как 'zh' в общем brg_lang.
  const legacyGlobal = getStoredLang(LANG_STORAGE_KEY);
  if (legacyGlobal === 'zh') {
    return 'ru';
  }

  return 'en';
};

export default function GetUserLang(): UserLang {
  localStorage.removeItem('brg_input_lang_set');

  const langFromUrl = getLangFromUrl();
  if (langFromUrl) {
    return langFromUrl;
  }

  // dafes.net (kz/*): дефолт — en, второй язык — ru.
  // Свой ключ brg_lang_kz, чтобы не подхватывать ru с других доменов/localhost.
  if (AppTester.isKz()) {
    return getKzLang();
  }

  if (AppTester.isOnlinesDesign()) {
    localStorage.setItem('brg_input_lang_set', JSON.stringify(['FR', 'EN']));
    return 'fr';
  }

  if (AppTester.isFr()) {
    localStorage.setItem('brg_input_lang_set', JSON.stringify(['FR', 'EN']));
    return 'en';
  }

  if (process.env.REACT_APP_API_CONNECTION_MODE === 'develop') {
    if (AppTester.isMediiiaArt()) {
      return 'zh';
    }
  }

  // Пробуем взять из cookie
  const cookieLang = getCookie(LANG_STORAGE_KEY);
  if (cookieLang === 'ru' || cookieLang === 'en') {
    return cookieLang;
  }

  // Пробуем взять из localStorage
  const storageLang = localStorage.getItem(LANG_STORAGE_KEY);
  if (storageLang === 'ru' || storageLang === 'en') {
    return storageLang;
  }

  const contextLang = getContextLang();

  if (contextLang) {
    return contextLang;
  }

  // Fallback — язык браузера
  const navLang = navigator.language || (navigator as any).userLanguage;
  return navLang.startsWith('ru') ? 'ru' : 'en';
}

/**
 * Сохраненяем язык который выбрали
 */
export function SaveUserLang(lang: 'ru' | 'en' | 'zh'): void {
  const domain = getTopDomain(2);

  if (AppTester.isKz() && (lang === 'ru' || lang === 'en')) {
    localStorage.setItem(KZ_LANG_STORAGE_KEY, lang);
    setCookie(KZ_LANG_STORAGE_KEY, lang, { domain });
    return;
  }

  localStorage.setItem(LANG_STORAGE_KEY, lang);
  setCookie(LANG_STORAGE_KEY, lang, { domain });
}
/**
 * Получение языка пользователя
 */
import { ApplicationShared } from "core";
import { getCookie, getTopDomain, setCookie } from "../../../../helpers/cookies";
import { DEZIIIGN_CONTEXTS, MEDIIIA_CONTEXTS } from "shared/constants/enginePaths";
import { AppTester } from "supporting";

type UserLang = 'ru' | 'en' | 'zh' | 'fr';

const LANG_STORAGE_KEY = 'brg_lang';
const KZ_LANG_STORAGE_KEY = 'brg_lang_kz';

const isUserLang = (lang: string | null): lang is UserLang => {
  if (!lang) return false;
  return ['ru', 'en', 'zh', 'fr'].includes(lang);
}

const getContextLang = () => {
  const app = ApplicationShared.application;

  if (typeof window !== 'undefined' && AppTester.isPromtWeekend()) {
    return 'ru';
  }

  if (['deziiign/lpudesign'].includes(app)) {
    return 'en';
  }
  if ([
    ...MEDIIIA_CONTEXTS,
    ...DEZIIIGN_CONTEXTS,
    'geograffee/dafes',
    'deziiign/lpudesign'
  ].includes(app)) {
    return 'ru';
  }
}

function getStoredLang(storageKey = LANG_STORAGE_KEY): UserLang | null {
  const cookieLang = getCookie(storageKey);
  if (isUserLang(cookieLang)) {
    return cookieLang;
  }
  const storageLang = localStorage.getItem(storageKey);
  if (isUserLang(storageLang)) {
    return storageLang;
  }
  return null;
}

const getLangFromUrl = (): UserLang | null => {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);
  const lang = urlParams.get('lang');

  if (isUserLang(lang)) {
    return lang;
  }
  return null;
}

const getKzLang = (): UserLang => {
  const kzStored = getStoredLang(KZ_LANG_STORAGE_KEY);
  if (kzStored === 'ru' || kzStored === 'en') {
    return kzStored;
  }

  // Legacy: раньше для dafes русский слот хранился как 'zh' в общем brg_lang.
  const legacyGlobal = getStoredLang(LANG_STORAGE_KEY);
  if (legacyGlobal === 'zh') {
    return 'ru';
  }

  return 'en';
};

export default function GetUserLang(): UserLang {
  localStorage.removeItem('brg_input_lang_set');

  const langFromUrl = getLangFromUrl();
  if (langFromUrl) {
    return langFromUrl;
  }

  // dafes.net (kz/*): дефолт — en, второй язык — ru.
  // Свой ключ brg_lang_kz, чтобы не подхватывать ru с других доменов/localhost.
  if (AppTester.isKz()) {
    return getKzLang();
  }

  if (AppTester.isOnlinesDesign()) {
    localStorage.setItem('brg_input_lang_set', JSON.stringify(['FR', 'EN']));
    return 'fr';
  }

  if (AppTester.isFr()) {
    localStorage.setItem('brg_input_lang_set', JSON.stringify(['FR', 'EN']));
    return 'en';
  }

  if (process.env.REACT_APP_API_CONNECTION_MODE === 'develop') {
    if (AppTester.isMediiiaArt()) {
      return 'zh';
    }
  }

  // Пробуем взять из cookie
  const cookieLang = getCookie(LANG_STORAGE_KEY);
  if (cookieLang === 'ru' || cookieLang === 'en') {
    return cookieLang;
  }

  // Пробуем взять из localStorage
  const storageLang = localStorage.getItem(LANG_STORAGE_KEY);
  if (storageLang === 'ru' || storageLang === 'en') {
    return storageLang;
  }

  const contextLang = getContextLang();

  if (contextLang) {
    return contextLang;
  }

  // Fallback — язык браузера
  const navLang = navigator.language || (navigator as any).userLanguage;
  return navLang.startsWith('ru') ? 'ru' : 'en';
}

/**
 * Сохраненяем язык который выбрали
 */
export function SaveUserLang(lang: 'ru' | 'en' | 'zh'): void {
  const domain = getTopDomain(2);

  if (AppTester.isKz() && (lang === 'ru' || lang === 'en')) {
    localStorage.setItem(KZ_LANG_STORAGE_KEY, lang);
    setCookie(KZ_LANG_STORAGE_KEY, lang, { domain });
    return;
  }

  localStorage.setItem(LANG_STORAGE_KEY, lang);
  setCookie(LANG_STORAGE_KEY, lang, { domain });
}
